import { configureStore } from '@reduxjs/toolkit';
import sankalpaReducer from './sankalpaSlice';
import bidhiReducer from './bidhiSlice';
import pujaReducer from './pujaSlice';

export const store = configureStore({
  reducer: {
    sankalpa: sankalpaReducer,
    bidhi: bidhiReducer,
    puja: pujaReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;